// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"67d24edf","221":"d7f039d2","238":"c2b83f2a","239":"f2030aca","453":"fb246d6b","455":"50b1be03","857":"fd9bf2e8","977":"0363ba72"}[chunkId] + ".chunk.js";
};